import { defineComponent, computed, createElementBlock, openBlock, normalizeClass, Fragment, renderList, createVNode, mergeProps, withCtx, createBlock, createCommentVNode, createElementVNode, toDisplayString } from 'vue';
import _sfc_main$2 from './basler-components.es73.js';
/* empty css                       */
import _sfc_main$5 from './basler-components.es104.js';
/* empty css                        */
import _sfc_main$3 from './basler-components.es85.js';
/* empty css                       */
import _sfc_main$4 from './basler-components.es79.js';
/* empty css                       */
import _sfc_main$1 from './basler-components.es121.js';

const _hoisted_1 = ["onClick"];
const _hoisted_2 = { key: 1 };
const _hoisted_3 = { class: "download-cards__title" };
const _hoisted_4 = {
  key: 0,
  class: "download-cards__subtitle"
};
const _hoisted_5 = {
  key: 3,
  class: "download-cards__platforms"
};
const _hoisted_6 = { key: 0 };
const _hoisted_7 = { key: 1 };
const _hoisted_8 = ["title"];
const _hoisted_9 = { class: "visually-hidden" };
const _hoisted_10 = {
  key: 5,
  class: "download-cards__description"
};
const _hoisted_11 = { key: 0 };
const _hoisted_12 = ["innerHTML"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "DownloadCards",
  props: {
    size: { default: "full" },
    items: {},
    isLoading: { type: Boolean, default: false }
  },
  emits: ["open"],
  setup(__props, { emit: __emit }) {
    const props = __props;
    const emit = __emit;
    const useCols = computed(() => {
      return [4, 6, 12];
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("ul", {
        class: normalizeClass(["download-cards", `download-cards--${props.size}`])
      }, [
        (openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.items, (item) => {
          return openBlock(), createElementBlock("li", {
            key: item.id,
            class: "download-cards__item",
            onClick: ($event) => item.isModal ? emit("open", item.id) : false
          }, [
            createVNode(_sfc_main$1, mergeProps({ ref_for: true }, item.isModal ? null : item.link || null, { "is-renderless": true }), {
              default: withCtx(() => [
                createVNode(_sfc_main$2, {
                  "has-link-behavior": true,
                  "card-data-attributes": item.cardDataAttributes ?? void 0
                }, {
                  header: withCtx(() => [
                    _ctx.isLoading ? (openBlock(), createBlock(_sfc_main$3, {
                      key: 0,
                      class: "download-cards__loading-media"
                    })) : (openBlock(), createBlock(_sfc_main$5, {
                      key: 1,
                      media: item.header,
                      cols: useCols.value,
                      lazyload: true
                    }, null, 8, ["media", "cols"]))
                  ]),
                  default: withCtx(() => [
                    _ctx.isLoading ? (openBlock(), createBlock(_sfc_main$3, {
                      key: 0,
                      class: "download-cards__loading-headline"
                    })) : (openBlock(), createElementBlock("hgroup", _hoisted_2, [
                      createElementVNode("h4", _hoisted_3, toDisplayString(item.title), 1),
                      item.subtitle ? (openBlock(), createElementBlock("h5", _hoisted_4, toDisplayString(item.subtitle), 1)) : createCommentVNode("", true)
                    ])),
                    _ctx.isLoading ? (openBlock(), createBlock(_sfc_main$3, {
                      key: 2,
                      class: "download-cards__loading-content"
                    })) : (openBlock(), createElementBlock("div", _hoisted_5, [
                      item.platformsLabel ? (openBlock(), createElementBlock("span", _hoisted_6, toDisplayString(item.platformsLabel), 1)) : createCommentVNode("", true),
                      item.platforms ? (openBlock(), createElementBlock("ul", _hoisted_7, [
                        (openBlock(true), createElementBlock(Fragment, null, renderList(item.platforms, (platform, platformIndex) => {
                          return openBlock(), createElementBlock("li", {
                            key: platformIndex,
                            class: "download-cards__platforms-item",
                            title: platform.text
                          }, [
                            createVNode(_sfc_main$4, {
                              name: platform.iconName
                            }, null, 8, ["name"]),
                            createElementVNode("span", _hoisted_9, toDisplayString(platform.text), 1)
                          ], 8, _hoisted_8);
                        }), 128))
                      ])) : createCommentVNode("", true)
                    ])),
                    _ctx.isLoading ? (openBlock(), createBlock(_sfc_main$3, {
                      key: 4,
                      class: "download-cards__loading-content"
                    })) : item.description ? (openBlock(), createElementBlock("div", _hoisted_10, [
                      item.descriptionLabel ? (openBlock(), createElementBlock("span", _hoisted_11, toDisplayString(item.descriptionLabel), 1)) : createCommentVNode("", true),
                      createElementVNode("div", {
                        innerHTML: item.description
                      }, null, 8, _hoisted_12)
                    ])) : createCommentVNode("", true)
                  ]),
                  _: 2
                }, 1032, ["card-data-attributes"])
              ]),
              _: 2
            }, 1040)
          ], 8, _hoisted_1);
        }), 128))
      ], 2);
    };
  }
});

export { _sfc_main as default };
